import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { BusinessUserResource } from 'src/app/interfaces/business-user-resource';
import { EventResource } from 'src/app/interfaces/event-resource';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { EventService } from 'src/app/services/event.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-add-reservation',
  templateUrl: './add-reservation.component.html',
  styleUrls: ['./add-reservation.component.scss']
})
export class AddReservationComponent implements OnInit {
  /**
   * Is the page loaded
   */
  finishedLoading: boolean = false;
  /**
   * The current index of the selcted user
   */
  selectedUser = -1;
  /**
 * The current index of the selcted Event
 */
  selectedEvent = -1;
  /**
   * Has a user been selecte from the List
   */
  selectedAUser: boolean = false;
  /**
   * The Current Page
   */
  page = null;
  /**
   * The Page Metadata
   */
  pageComponents = {
    pageIndex: 0,
    pageSize: 8
  }
/**
 * The CurrentPage of Events
 */
  pageEvents = null;
  /**
   * The Metadata of Events
   */
  pageComponentsEvents = {
    pageIndex: 0,
    pageSize: 8
  }
  /**
   * has a user been selected from the list
   */
  selectedBusinessuser: boolean = false;
  /**
   * addFormEventForm
   */
  addFormEvent: UntypedFormGroup;
  /**
   * Form
   */
  addFormUser: UntypedFormGroup;
  /**
   * Form
   */
  addForm: UntypedFormGroup;
  /**
   * The Data of Users to be displayed
   */
  dataSource: MatTableDataSource<BusinessUserResource>;
    /**
   * The Data of Events to be displayed
   */
  dataSourceEvents: MatTableDataSource<EventResource>;
  /**
   * The current User Object
   */
  currentUser: BusinessUserResource;
    /**
   * The current Event Object
   */
  currentEvent: EventResource;
  /**
   * The columns of the user Table
   */
  displayedColumns = ['menu', 'user'];
    /**
   * The columns of the Event Table
   */
  displayedColumnsEvents = ['menu', 'user'];
  /**
   * constructor
   * Init the Form
   * @param businessuserService 
   * @param eventService 
   * @param overlay 
   * @param fb 
   * @param router 
   * @param route 
   */
  constructor(
    private businessuserService: BusinessuserService,
    private eventService: EventService,
    private overlay: OverlayService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute) {
    this.addFormEvent = this.fb.group({
      searchTerm: [''],
      event: ['', [Validators.required]],
    })
    this.addFormUser = this.fb.group({
      searchTerm: [''],
      user: ['', [Validators.required]],
    })
    this.addForm = this.fb.group({
      emailNotify: [false, []],
      force: [false, []],
    })
  }
  /**
   * ngOnInit
   * getAllBusinessUsersWtihFilter
   * searchForEvents
   */
  ngOnInit(): void {
    combineLatest([
      this.businessuserService.getAllBusinessUsersWtihFilter(this.pageComponents.pageIndex, this.pageComponents.pageSize, null, null, ["ACTIVE", "PENDING"], null, null, null, null, null, ["ROLE_CUSTOMER"]),
      this.eventService.searchForEvents(this.pageComponentsEvents.pageIndex, this.pageComponentsEvents.pageSize, ["CREATED", "ACTIVE", "PREVIEW", "HIDDEN", "EXPIRED"], ["MONETARY", "SERVICE_PLUS", "RAFFLE"], null, null)
    ]).pipe(
      map(([users, events]: any) => {
        this.page = users.page
        this.dataSource = new MatTableDataSource(users.content);
        this.pageEvents = events.page
        this.dataSourceEvents = new MatTableDataSource(events.content);
      })).subscribe(
        result => {
          this.finishedLoading = true;
        },
        error => {
          console.log("error: ", error);
          this.overlay.openErrorDialog("Fehler beim Laden", "Versuchen Sie es bitte später noch einmal. Sollte das Problem nicht in absehbarer Zeit behoben sein, schreiben Sie uns eine E-Mail an: support@plusservices.de", "Zurück zur Übersicht")
        }
      );
  }
  /**
   * Select the event to be active
   * @param event 
   */
  setActiveEvent(event: EventResource) {
    this.currentEvent = event;
    this.addFormEvent.patchValue({
      event: event
    })
  }
  /**
   * Select the user to be active
   * @param user 
   */
  setActiveUser(user: BusinessUserResource) {
    this.addFormUser.controls.user.setValue(null)
    this.selectedAUser = true;
    this.currentUser = user;
    this.addFormUser.patchValue({
      user: user
    })
  }
  /**
   * Load the Page of Users
   * @param event 
   */
  loadPage(event?: PageEvent) {
    this.pageComponents.pageIndex = event.pageIndex;
    this.pageComponents.pageSize = event.pageSize;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: event.pageIndex,
          size: event.pageSize,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        return this.filterUsers();
      })
  }
  /**
   * Filter the Users With the Filter from the Form
   */
  filterUsers() {
    this.businessuserService.getAllBusinessUsersWtihFilter(this.pageComponents.pageIndex, this.pageComponents.pageSize, this.addFormUser.value.searchTerm, null, ["ACTIVE", "PENDING"], null, null, null, null, null, ["ROLE_CUSTOMER"]).subscribe((users: PagedResources<BusinessUserResource>) => {
      this.page = users.page
      this.dataSource = new MatTableDataSource(users.content);
    })
  }
  /**
   * Filter the Events With the Filter from the Form
   */
  filterEvents() {
    this.eventService.searchForEvents(this.pageComponentsEvents.pageIndex, this.pageComponentsEvents.pageSize, ["CREATED", "ACTIVE", "PREVIEW", "HIDDEN", "EXPIRED"], ["MONETARY", "SERVICE_PLUS","RAFFLE"], null, this.addFormEvent.value.searchTerm).subscribe((events: PagedResources<EventResource>) => {
      this.pageEvents = events.page
      this.dataSourceEvents = new MatTableDataSource(events.content);
    })
  }

  /**
   * Search for All BusinessUsers Wtih Filter
   * @param pageIndex 
   * @param pageSize 
   */
  search(pageIndex, pageSize) {
    this.businessuserService.getAllBusinessUsersWtihFilter(pageIndex, pageSize, null, null, ["ACTIVE", "PENDING"], null, null, null, null, null, ["ROLE_CUSTOMER"]).subscribe((users: PagedResources<BusinessUserResource>) => {
      this.page = users.page
      this.dataSource = new MatTableDataSource(users.content);
    })
  }
  /**
   * Load a Page of Events 
   * @param event 
   * @returns 
   */
  loadPageEvent(event?: PageEvent) {
    this.pageComponentsEvents.pageIndex = event.pageIndex;
    this.pageComponentsEvents.pageSize = event.pageSize;
    return this.filterEvents();
  }

  /**
   * Search to the Page of Events
   * @param pageIndex 
   * @param pageSize 
   */
  searchEvent(pageIndex, pageSize) {
    this.eventService.searchForEvents(pageIndex, pageSize, ["CREATED", "ACTIVE", "PREVIEW", "HIDDEN", "EXPIRED"], ["MONETARY", "SERVICE_PLUS", "RAFFLE"], null, null).subscribe((events: PagedResources<EventResource>) => {
      this.pageEvents = events.page
      this.dataSourceEvents = new MatTableDataSource(events.content);
    })
  }
  /**
   * crate a new Reservatio  for the current user and the current Event
   */
  createReservation() {
    this.eventService.createReservation(this.currentUser, this.currentEvent, this.addForm.value.emailNotify, this.addForm.value.force).subscribe((fromCreate: any) => {
      if (fromCreate.success == true) {
        this.overlay.openSnackBar("Gutschein erfolgreich erstellt!");
        this.router.navigate(["caseworker/reservation"])
      } else if (fromCreate.success == false && fromCreate.reservationHurdles.length != 0) {
        this.overlay.openSnackBar(fromCreate.reservationHurdles[0].message)
      } else if (fromCreate.success == false && fromCreate.reservationHurdles.length == 0) {
        this.overlay.openSnackBar("Es ist ein unerwarteter Fehler aufgetreten, bitte versuchen Sie es erneut.")
      }
    })
  }
}
